export const ASSET_PATHS = {
    logos: {
        white: '/images/logos/wanzl-white-220.png',
        blue: '/images/logos/wanzl-blue-220.png',
        wanzl: '/images/logos/wanzl-logo.svg',
        site: '/images/logos/site-logo.png'
    },

    backgrounds: {
        login: '/images/backgrounds/login-bg.jpeg',
        sidebar: {
            option1: '/images/backgrounds/sidebar-1.jpg'
        }
    },

    flags: {
        en: '/images/flags/en.png',
        de: '/images/flags/de.png'
    },

    icons: {
        loading: '/images/icons/loading.svg'
    }
} as const;
